import { User } from "data/api";

export default ({ firstName, lastName }: User) => {
  if (firstName === null || lastName === null) return "";
  return `${firstName || ""}${firstName ? " " + lastName : lastName || ""}`;
};
